import Vue from 'vue';
import App from './components/App.vue';
import store from './store';
var element = document.querySelector('[data-pem-course]');
if (element) {
	new Vue({
		el: '[data-pem-course]',
		render: (h) => h(App),
		store
	});
}
